import { useIndustriesNavbarScroll } from './useIndustriesNavbarScroll/useNavbarScroll'

export { useIndustriesNavbarScroll }
